import ViewEventPage from "./ViewEventPage";

export default ViewEventPage;
